import React from 'react';
import { Box, GridList, GridListTile, makeStyles } from "@material-ui/core";
import ImageUploader from '../UI/ImageUploader';

const useStyles = makeStyles((theme) => ({
    vehicleImagesContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    vehicleImages: {
        maxWidth: '586px'
    }
}));

const ImageGridUploader = (props) => {
    const classes = useStyles();

    return (
        <Box className={classes.vehicleImagesContainer}>
            <GridList className={classes.vehicleImages} cols={3} cellHeight={90+26-4}>
                {props.formImageIds.map(formImageId => {
                    return (<GridListTile key={formImageId} cols={1}>
                                <ImageUploader type={'newCarPhotos'} formState={props.formState} setFormState={props.setFormState} 
                                    datakey={formImageId}
                                    onLoad={props.onLoad} onError={props.onError} />
                            </GridListTile>)
                })}
            </GridList>  
        </Box>
    );
}

export default ImageGridUploader;